var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1973_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.333 15.334H15.333V16.6673H11.333V15.334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 16.073L11.067 13.133V11.9263L4.66699 8.98633V10.453L9.19366 12.533L4.66699 14.6063V16.073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.333 8.81398V19.334H2.66634V7.20065H16.1597C15.8934 6.87458 15.6694 6.51619 15.493 6.13398H2.66634V4.66732H15.0463C15.0159 4.44638 15.0003 4.22367 14.9997 4.00065C15.0003 3.77764 15.0159 3.55492 15.0463 3.33398H2.66634C2.31272 3.33398 1.97358 3.47446 1.72353 3.72451C1.47348 3.97456 1.33301 4.3137 1.33301 4.66732V19.334C1.33301 19.6876 1.47348 20.0267 1.72353 20.2768C1.97358 20.5268 2.31272 20.6673 2.66634 20.6673H21.333C21.6866 20.6673 22.0258 20.5268 22.2758 20.2768C22.5259 20.0267 22.6663 19.6876 22.6663 19.334V8.22732C22.2529 8.48691 21.8037 8.68457 21.333 8.81398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 7.33268C21.8413 7.33268 23.3337 5.8403 23.3337 3.99935C23.3337 2.1584 21.8413 0.666016 20.0003 0.666016C18.1594 0.666016 16.667 2.1584 16.667 3.99935C16.667 5.8403 18.1594 7.33268 20.0003 7.33268Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1973_395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntel);
export default __webpack_public_path__ + "static/media/intel.840b2b4d24c2c712322c1c9ccaed4d19.svg";
export { ForwardRef as ReactComponent };